<template lang="pug">
  #Contacts
    appHeader(
      :targetRouterName="route"
      :title="'顧客通訊錄'"
    )
    router-view.content-body-hasFooter
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';
import appSaFooter from '@/components/partials/AppSaFooter.vue';
import { SA_ITEMS_LIST_INDEX } from '@/router/sa/items-list';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'ContactsComponent',
  components: {
    appHeader,
    appSaFooter
  },
  data() {
    return {
      route: SA_ITEMS_LIST_INDEX
    };
  }
};
</script>
